/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import controlledAccordionStyles from "./controlledAccordionStyles";
import _map from "lodash/map";
import { Link } from "react-router";
import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Box } from "@mui/material";
import { AccordionContent, isAccordionContentWithLink } from "../../types/AccordionContent";
import { gaEvent } from "../../services/googleAnalyticsService";

type ControlledAccordionProps = {
  contentList: Array<AccordionContent>;
  idPrefix: string;
  name: string;
};

const ControlledAccordion = ({ contentList, idPrefix, name }: ControlledAccordionProps) => {
  const [expanded, setExpanded] = React.useState<string | false>("");

  const handleChange = (panelName: string, accordionName: string, heading: string) => (event: React.FormEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panelName : false);
    gaEvent({
      category: "Accordion " + accordionName,
      action: "Click",
      label: heading,
    });
  };

  const handleLinkClick = (accordionName: string, link: string) => {
    gaEvent({
      category: "Accordion " + accordionName,
      action: "linkClick",
      label: "To: " + link,
    });
  };

  return (
    <div id={idPrefix + "-accordion"}>
      {_map(contentList, (content) => {
        let panelName = "panel" + content.id;
        return (
          <Accordion key={panelName} expanded={expanded === panelName} onChange={handleChange(panelName, name, content.heading)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} id={panelName + "-header"}>
              <Box sx={controlledAccordionStyles.heading}>{content.heading}</Box>
            </AccordionSummary>
            <AccordionDetails>{content.text}</AccordionDetails>
            <AccordionDetails>
              {isAccordionContentWithLink(content) && (
                <Link to={content.link} onClick={() => handleLinkClick(name, content.link)}>
                  {content.linkText ? content.linkText : "Mehr erfahren"}
                </Link>
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
};

export default ControlledAccordion;
